export enum PropertyConfigurationForms {
  Update = 'Update',
}
